import type { IconSvgObject } from './types';

const FallingStarIcon: IconSvgObject = [
  ["path", { d: "M22 2L14 10M16 2L11 7M20 10L17 13", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 22L8 20.5L12 22L11.5 18L14 15L10.5 14L8 10.5L5.5 14L2 15L4.5 18L4 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.55", key: "1" }]
];

export default FallingStarIcon;
